import { Localize } from '../../locales';
import { SearchFilterConfigProps } from '../../../app/ui/components/Search/SearchFilter';

export type SearchFilterConfig = Localize<SearchFilterConfigProps>;

export const searchFilterConfig: SearchFilterConfig = {
	en: {},
	fr: {}
};
